import GlossaryContent from "../../components/others/glossaryScreen/GlossaryContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import SystemAppScreenHeader from "../../components/headers/SystemAppScreenHeader";
import {kSystemIcons} from "../../constants/icons";
import {useState} from "react";
import GlossaryScreenInfoDialog from "../../components/dialogs/glossaryScreen/GlossaryScreenInfoDialog";

export default function GlossaryScreen() {
    // Used in index.js by the router as an entry point
    // for compulsory legal texts, in tablet and desktop modes

    // PROPERTIES
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

    // BUILD
    return (
        <div className="overflow-auto w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Glossaire')}</title>
                <meta name="description"
                      content="Liste des termes mathématiques à connaître au collège." />
            </Helmet>
            {/** MODAL */}
            <GlossaryScreenInfoDialog open={isInfoModalOpen}
                                      handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"animate-appearSlow grow w-full flex flex-col justify-start items-center min-h-0"}>
                <div className={"w-full p-[16px]"}>
                    <SystemAppScreenHeader title={"Glossaire mathématique"}
                                           icon={kSystemIcons.dictionary}
                                           onInfoClick={processModalOpening}
                                           isBrevetDisplay={false} />
                </div>
                <GlossaryContent />
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isInfoModalOpen) {
            setIsInfoModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isInfoModalOpen) {
            setIsInfoModalOpen(false)
        }
    }
}